import { FC } from "react";
import { Paperclip } from "react-feather";
import { Avatar, AvatarInitial } from "../../Common/Avatar";
import Heading from "../../Common/Heading";
import Text from "../../Common/Text";
import { MediaBody } from "../../UI/Media";
import { StyledMedia, StyledTop } from "./style";

interface IProps {
  color?: string;
  image?: string;
  name: string;
  time: string;
  title: string;
  excerpt: string;
  status?: "read" | "unread";
  numAttachments?: number;
  onClick?: () => void;
}

const GroupItem: FC<IProps> = ({
  color,
  image,
  name,
  time,
  title,
  excerpt,
  status,
  numAttachments,
  onClick,
}) => {
  return (
    <StyledMedia className={status} onClick={onClick}>
      <Avatar>
        {!image && (
          <AvatarInitial bg={color}>{name.substring(0, 1)}</AvatarInitial>
        )}
        {image && <img src={image} alt="name" />}
      </Avatar>
      <MediaBody ml="15px">
        <StyledTop>
          <Text className="title-name" as="span" fontSize="12px">
            {name}
          </Text>
          <Text as="span" fontSize="11px">
            {numAttachments && numAttachments > 0 && (
              <span>
                {numAttachments} <Paperclip size={"11px"} />
              </span>
            )}{" "}
            {time}
          </Text>
        </StyledTop>
        <Heading fontSize="13px" fontWeight={status === "unread" ? 600 : 400}>
          {title}
        </Heading>
        <Text fontSize="12px" color="text3">
          {excerpt}
        </Text>
      </MediaBody>
    </StyledMedia>
  );
};

GroupItem.defaultProps = {
  status: "read",
};

export default GroupItem;
